/* RATING */
export const GET_RATING_LIST = "GET_RATING_LIST";
export const GET_RATING_LIST_SUCCESS = "GET_RATING_LIST_SUCCESS";
export const GET_RATING_LIST_FAIL = "GET_RATING_LIST_FAIL";

export const SET_FILTER_RATING_LIST = "SET_FILTER_RATING_LIST";
export const RESET_FILTER_RATING_LIST = "RESET_FILTER_RATING_LIST";
